/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./nMenu.vue?vue&type=template&id=cf5f73c0&scoped=true"
import script from "./nMenu.vue?vue&type=script&lang=js"
export * from "./nMenu.vue?vue&type=script&lang=js"
import style0 from "./nMenu.vue?vue&type=style&index=0&id=cf5f73c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5f73c0",
  null
  
)

export default component.exports